








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Label extends Vue {
  @Prop({ type: String, default: '' })
  readonly label!: string;

  @Prop({ type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly bigLabel!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/form/components/components/label/Label.vue